enum FreeTrialRestriction {
  FREE_TRIAL_ALREADY_SUBSCRIBED = 'free-trial.already-subscribed',
  PRODUCT_ALREADY_PURCHASED = 'free-trial.product.already-purchased'
}

export default FreeTrialRestriction;
